$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-xlim-pod-kit');
})

$('.pnr_cart').click(function(){
    var element = document.querySelector(".xlim_nc-sec7");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".xlim_pd-sec10");
    element.scrollIntoView({block: "end"});
})

//section1
$(document).ready(function(){
    if(window.width > 768){
var controller = new ScrollMagic.Controller();
var pinIntroScene = new ScrollMagic.Scene({
    triggerElement: "#xlim_nc-sec1",
    triggerHook: 0,
    duration: '99%'
})
.setPin("#xlim_nc-sec1", {pushFollowers: false})
.addTo(controller);

var pinIntroScene2 = new ScrollMagic.Scene({
    triggerElement: "#xlim_nc-sec2",
    triggerHook: 0,
    duration: '100%'
})
.setPin("#xlim_nc-sec2", {pushFollowers: true})
.addTo(controller);
}
})


//section3 mobile
window.onload = (event) => {

    if(window.innerWidth < 581){
            
        const sec3img = document.querySelector('.xlim_pd-sec3__img-slide');
        let transXval = -27.2;
        sec3img.style.transform = `translateX(${transXval}%)`;
    
    
    
        // get gesture
        let touchstartX = 0;
        let touchstartY = 0;
        let touchendX = 0;
        let touchendY = 0;

        const gestureZone = sec3img;

        gestureZone.addEventListener('touchstart', function(event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        }, false);

        gestureZone.addEventListener('touchend', function(event) {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleGesture();
        }, false); 


        // slide changes
        function handleGesture() {
            if (touchendX <= touchstartX) {
                if(transXval === -27.2){
                    transXval = -43;
                    sec3img.style.transform = `translateX(${transXval}%)`
                }
                if(transXval === -11.8){
                    transXval = -27.2;
                    sec3img.style.transform = `translateX(${transXval}%)`
                }
            }
            
            if (touchendX >= touchstartX) {
                if(transXval === -27.2){
                    transXval = -11.8;
                    sec3img.style.transform = `translateX(${transXval}%)`
                }
                if(transXval === -43){
                    transXval = -27.2;
                    sec3img.style.transform = `translateX(${transXval}%)`
                }
                
            }
        };
    };
};

//section11
new Swiper('.xlimpodSwiper', {
	navigation: { 
        nextEl: '.xPswiper-button-prev',
        prevEl: '.xPswiper-button-next',
    },
})

new Swiper('.MxlimpodSwiper', {
    pagination: {
        el: '.MxPswiper-pagination',
      },
})